<style scoped="scoped" lang="scss">
.inputClass /deep/ .el-input__inner {
  height: 38px !important;
}

.inputClass /deep/ .el-input__icon {
  //width: 25px !important;;
  line-height: 20px !important;
}
.currentTable /deep/ .el-table__body .el-table__row {
  height: 75px !important;
}

::v-deep .transparent-select .el-input__inner {
  border: none !important; // 去掉边框
  background-color: transparent; // 背景透明
  padding: 0 10px;
}

::v-deep .work_hour_dialog_yt {
  .el-select {
    min-width: auto;
    width: 100%;
  }
  .el-input {
    min-width: auto;
    width: 100%;
  }
}

.center-form {
  width: 80%;
  margin: 0 auto;
}
</style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/work/hour/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('gongshileixing')">
            <yi_dictionary_select :type="'WORK_HOUR_TYPE'" :ids.sync="yt.conditions.type"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('gonghao')">
            <el-input v-model="yt.conditions.employeeNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('xingming')">
            <el-input v-model="yt.conditions.employeeName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('caijibiaoshi')">
            <yi_dictionary_select :type="'WORK_HOUR_COLLECT_FLAG'" :ids.sync="yt.conditions.collectFlag"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('caijishijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.collectTimeStart" :end.sync="yt.conditions.collectTimeEnd"> </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('shebei')">
            <yi_cross_select :component="'web_base_equipment_list'" :selectTitle="'name'" :max="1" :ids.sync="yt.conditions.equipmentIds"></yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('laiyuanleixing')">
            <yi_dictionary_select :type="'WORK_HOUR_SOURCE_TYPE'" :ids.sync="yt.conditions.sourceType"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ orderBy: 'createTime desc' })">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button
          size="mini"
          @click="
            yt.showEditDialog('xinzeng', null, 'w1');
            getCurrentAndNextShift();
          "
          type="primary"
          v-if="utils.checkPower('web_employment_management_work_hour_create')"
        >
          {{ $t('gongshiluru') }}
        </el-button>
        <el-button
          size="mini"
          @click="
            yt.showEditDialog('paiban', null, 'w1');
            getCurrentAndNextShift();
            getTeamMembers();
          "
          type="primary"
          v-if="utils.checkPower('web_employment_management_work_hour_leader_schedule_button')"
        >
          {{ $t('paiban') }}
        </el-button>
        <el-button size="mini" type="primary" @click="reuseRecentSchedule()" v-if="utils.checkPower('web_employment_management_work_hour_leader_schedule_reuse_button')">{{ $t('fuyongzuijinpaiban') }}</el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 操作列 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="utils.checkPower('web_employment_management_work_hour_update') && !scope.row.staffAllocation">
            <el-button type="text" @click="getEditTeamMembers(scope.row);">
              {{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1" v-if="utils.checkPower('web_employment_management_work_hour_deleteByIds') && !scope.row.staffAllocation">
            <el-button type="text" class="font-color-danger" @click="showDeleteDialog(scope.row)">
              {{ $t('shanchu') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增或编辑 -->
      <template v-if="yt.editObj.action == 'xinzeng' || yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('gongshileixing')" required>
            <yi_dictionary_select :type="'WORK_HOUR_TYPE'" :ids.sync="yt.editObj.type" @change="handleWorkTypeChange"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('renyuan')" required v-if="yt.editObj.action == 'xinzeng'">
            <yi_cross_select multiple :selectTitle="'name'" :component="'web_employment_management_employee_component'" :ids.sync="yt.editObj.employeeIds"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('renyuan')" required v-if="yt.editObj.action == 'bianji'">
            <el-select class="editTeam" v-model="yt.editObj.employeeId" filterable placeholder="请选择人员">
              <el-option v-for="(employee, empIndex) in editTeamWorkingEmpList" :key="`edit-emp-${empIndex}-${employee.id}`" :label="`${employee.name} (${employee.jobNo})`" :value="employee.id">
                <span>{{ employee.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 12px">{{ employee.jobNo }}</span>
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('shebei')" required v-if="yt.editObj.action == 'xinzeng'">
            <yi_data_select multiple type="equipmentAll" :ids.sync="yt.editObj.equipmentIds" :queryFilter="e => teamEquipmentIds.includes(e.id)"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('shebei')" required v-if="yt.editObj.action == 'bianji'">
            <el-select class="editTeam" multiple v-model="yt.editObj.equipmentIds" filterable :placeholder="$t('qingxuanze')" :clearable="true">
              <el-option v-for="equipment in editTeamEquipmentList" :key="equipment.id" :label="equipment.name" :value="equipment.id">
                <span>{{ equipment.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 12px">{{ equipment.sn }}</span>
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('beizhu')">
            <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
          </el-form-item>

          <el-form-item :label="$t('caijishijian1')" required>
            <yi_time_input type="datetime" :time.sync="yt.editObj.collectTime"></yi_time_input>
            <div style="margin-top: 2px;" v-if="yt.editObj.action == 'xinzeng'">
              <el-link type="primary" @click="setShiftStartTime(1)" style="margin-right: 20px;">
                {{ $t('dangbankaishishijian') }}
              </el-link>
              <el-link type="primary" @click="setNextShiftStartTime(1)">
                {{ $t('xiayibancikaishishijian') }}
              </el-link>
            </div>
          </el-form-item>

          <el-form-item :label="$t('caijibiaoshi1')" required style="margin-bottom: 28px;">
            <yi_dictionary_select type="WORK_HOUR_COLLECT_FLAG" :ids.sync="yt.editObj.collectFlag" :disableIds="filterTypeOptions" :disabled="!yt.editObj.type"> </yi_dictionary_select>
          </el-form-item>

          <el-form-item :label="$t('caijishijian2')" v-if="yt.editObj.action == 'xinzeng'">
            <yi_time_input type="datetime" :time.sync="yt.editObj.collectTime2"></yi_time_input>
            <div style="margin-top: 2px;">
              <el-link type="primary" @click="setShiftStartTime(2)" style="margin-right: 20px;">
                {{ $t('dangbanjieshushijian') }}
              </el-link>
              <el-link type="primary" @click="setNextShiftStartTime(2)">
                {{ $t('xiayibancijieshushijian') }}
              </el-link>
            </div>
          </el-form-item>

          <el-form-item :label="$t('caijibiaoshi2')" style="" v-if="yt.editObj.action == 'xinzeng'">
            <yi_dictionary_select type="WORK_HOUR_COLLECT_FLAG" :ids.sync="yt.editObj.collectFlag2" :disableIds="filterTypeOptions" :disabled="!yt.editObj.type"> </yi_dictionary_select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="closeNewDialog()">{{ $t('quxiao') }}</el-button>
          <el-button v-if="yt.editObj.action == 'xinzeng'" size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/work/hour/create', beforeCreate)" type="primary">
            {{ $t('baocun') }}
          </el-button>
          <el-button v-if="yt.editObj.action == 'bianji'" size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/work/hour/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>

      <!-- 排班 -->
      <template v-if="yt.editObj.action == 'paiban'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('gongshileixing')" required>
            <yi_dictionary_select :type="'WORK_HOUR_TYPE'" :ids.sync="yt.editObj.type" @change="handleWorkTypeChange"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('renyuan')" required>
            <el-select v-model="yt.editObj.employeeIds" multiple filterable placeholder="请选择人员" style="width: 100%">
              <el-option v-for="(employee, empIndex) in teamWorkingEmpList" :key="`team-emp-${empIndex}-${employee.id}`" :label="`${employee.name} (${employee.jobNo})`" :value="employee.id">
                <span>{{ employee.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 12px">{{ employee.jobNo }}</span>
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('shebei')" required>
            <yi_data_select multiple type="equipmentAll" :ids.sync="yt.editObj.equipmentIds" :queryFilter="e => teamEquipmentIds.includes(e.id)"></yi_data_select>
          </el-form-item>

          <el-form-item :label="$t('beizhu')">
            <el-input type="textarea" v-model="yt.editObj.remark"></el-input>
          </el-form-item>

          <el-form-item :label="$t('caijishijian1')" required>
            <yi_time_input type="datetime" :time.sync="yt.editObj.collectTime"></yi_time_input>
            <div style="margin-top: 2px;" v-if="yt.editObj.action == 'paiban'">
              <el-link type="primary" @click="setShiftStartTime(1)" style="margin-right: 20px;">
                {{ $t('dangbankaishishijian') }}
              </el-link>
              <el-link type="primary" @click="setNextShiftStartTime(1)">
                {{ $t('xiayibancikaishishijian') }}
              </el-link>
            </div>
          </el-form-item>

          <el-form-item :label="$t('caijibiaoshi1')" required style="margin-bottom: 28px;">
            <yi_dictionary_select type="WORK_HOUR_COLLECT_FLAG" :ids.sync="yt.editObj.collectFlag" :disableIds="filterTypeOptions" :disabled="!yt.editObj.type"> </yi_dictionary_select>
          </el-form-item>

          <el-form-item :label="$t('caijishijian2')">
            <yi_time_input type="datetime" :time.sync="yt.editObj.collectTime2"></yi_time_input>
            <div style="margin-top: 2px;">
              <el-link type="primary" @click="setShiftStartTime(2)" style="margin-right: 20px;">
                {{ $t('dangbanjieshushijian') }}
              </el-link>
              <el-link type="primary" @click="setNextShiftStartTime(2)">
                {{ $t('xiayibancijieshushijian') }}
              </el-link>
            </div>
          </el-form-item>

          <el-form-item :label="$t('caijibiaoshi2')">
            <yi_dictionary_select type="WORK_HOUR_COLLECT_FLAG" :ids.sync="yt.editObj.collectFlag2" :disableIds="filterTypeOptions" :disabled="!yt.editObj.type"> </yi_dictionary_select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="closeNewDialog()">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/work/hour/create', beforeCreate)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>

      <template v-if="yt.editObj.action == 'fuyongzuijinpaiban'">
        <div class="dialog-scroller" style="display: flex;flex-direction: column;">
          <div>
            <el-form size="mini" :inline="true" class="demo-form-inline">
              <el-form-item :label="$t('renyuan')">
                <el-select v-model="selectedEmployeeIds" multiple filterable placeholder="请选择人员">
                  <el-option v-for="(employee, empIndex) in teamWorkingEmpList" :key="`reuse-emp-${empIndex}-${employee.id}`" :label="`${employee.name} (${employee.jobNo})`" :value="employee.id">
                    <span>{{ employee.name }}</span>
                    <span style="float: right; color: #8492a6; font-size: 12px">{{ employee.jobNo }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('shebei')">
                <yi_data_select multiple type="equipmentAll" :ids.sync="selectedDeviceNames" :queryFilter="e => teamEquipmentIds.includes(e.id)"></yi_data_select>
              </el-form-item>
              <el-form-item :label="$t('gongshileixing')">
                <yi_dictionary_select :multiple="true" :max="10" :type="'WORK_HOUR_TYPE'" :ids.sync="selectedWorkTypes"> </yi_dictionary_select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="filterData">{{ $t('sousuo') }}</el-button>
                <el-button type="default" @click="clearSearch">{{ $t('chongzhi') }}</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div style="flex:1;" class="work_hour_dialog_yt">
            <yi_curd_table class="currentTable" :name="$options.name + '2'" ref="yt2" :columns="columnsItem">
              <template #buttonsL="scope">
                <el-button size="mini" @click="addTable(scope._index, $event)" type="primary">{{ $t('xinzeng') }}</el-button>
                <el-button size="mini" @click="showBatchUpdateDialog" type="primary">{{ $t('pilianggengxinriqi') }}</el-button>
              </template>
              <template #shebeimingcheng="scope">
                <yi_data_select v-if="!scope.row.id" type="equipmentAll" :ids.sync="scope.row.equipmentId" :queryFilter="e => deleteTeamEquipmentIds.includes(e.id)"></yi_data_select>
                <yi_data_select v-else type="equipmentAll" :ids.sync="scope.row.equipmentId" disabled></yi_data_select>
              </template>
              <template #gonghao="scope">
                {{ scope.row.gonghao }}
              </template>
              <template #xingming="scope">
                <el-select :key="`employee-${scope._index}-${scope.row.id || 'new'}`" v-model="scope.row.employeeIds" filterable placeholder="请选择人员" multiple @change="value => handleEmployeeChange(value, scope.row)" class="inputClass" :collapse-tags="true">
                  <el-option v-for="(employee, empIndex) in teamWorkingEmpList" :key="`emp-${empIndex}-${employee.id}`" :label="`${employee.name} (${employee.jobNo})`" :value="employee.id">
                    <span>{{ employee.name }}</span>
                    <span style="float: right; color: #8492a6; font-size: 12px; padding-right: 20px;">{{ employee.jobNo }}</span>
                  </el-option>
                </el-select>
              </template>
              <template #gongshileixing="scope">
                <yi_dictionary_select :key="`type-${scope._index}-${scope.row.id || 'new'}`" class="inputClass" :type="'WORK_HOUR_TYPE'" :ids.sync="scope.row.type"> </yi_dictionary_select>
              </template>
              <template #shangji="scope">
                <el-date-picker :key="`start-${scope._index}-${scope.row.id || 'new'}`" v-model="scope.row.collectTime" type="datetime" />
                <div style="margin-top: -1px;">
                  <el-link type="primary" @click="updateCollectTime(scope.row, currentShiftStart)" style="margin-right: 20px;">
                    {{ $t('dangbankaishishijian') }}
                  </el-link>
                  <el-link type="primary" @click="updateCollectTime(scope.row, currentShiftEnd)">
                    {{ $t('xiayibancikaishishijian') }}
                  </el-link>
                </div>
              </template>
              <template #xiaji="scope">
                <el-date-picker :key="`end-${scope._index}-${scope.row.id || 'new'}`" v-model="scope.row.collectTime2" type="datetime" />
                <div style="margin-top: -1px;">
                  <el-link type="primary" @click="updateCollectTime2(scope.row, nextShiftStart)" style="margin-right: 20px;">
                    {{ $t('dangbanjieshushijian') }}
                  </el-link>
                  <el-link type="primary" @click="updateCollectTime2(scope.row, nextShiftEnd)">
                    {{ $t('xiayibancijieshushijian') }}
                  </el-link>
                </div>
              </template>

              <template #caozuo="scope">
                <el-row :gutter="10">
                  <el-col :span="0.1">
                    <el-button type="text" class="font-color-danger" @click="remove(scope._index, $event)">
                      {{ $t('shanchu') }}
                    </el-button>
                  </el-col>
                </el-row>
              </template>
            </yi_curd_table>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="clearResueDialog">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" @click="submitFullData" type="primary" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { s1: '采购申请-创建采购订单保存' } }">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog :title="$t('pilianggengxinriqi')" :visible.sync="batchDialogVisible" width="500px" @close="resetBatchForm">
      <el-form ref="batchForm" :model="batchForm" label-width="100px" class="center-form">
        <el-form-item :label="$t('riqi')" required>
          <el-date-picker v-model="batchForm.date" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>

        <el-form-item :label="$t('banci')" required>
          <el-select v-model="batchForm.shiftId" placeholder="请选择班次" @change="handleShiftChange">
            <el-option v-for="shift in shiftOptions" :key="shift.value" :label="shift.label" :value="shift.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('shangjishijian')" required>
          <el-time-picker
            v-model="batchForm.startTime"
            :picker-options="{
              selectableRange: '00:00:00 - 23:59:59'
            }"
            format="HH:mm:ss"
            value-format="HH:mm:ss"
          ></el-time-picker>
        </el-form-item>

        <el-form-item :label="$t('xiajishijian')" required>
          <el-time-picker
            v-model="batchForm.endTime"
            :picker-options="{
              selectableRange: '00:00:00 - 23:59:59'
            }"
            format="HH:mm:ss"
            value-format="HH:mm:ss"
          ></el-time-picker>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="batchDialogVisible = false">{{ $t('quxiao') }}</el-button>
        <el-button type="primary" @click="handleBatchUpdate" :loading="batchLoading">{{ $t('baocun') }}</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="$t('删除确认')" :visible.sync="deleteRecordDialogVisible" width="50%" @close="deleteRecordDialogVisible = false">
      <span style="white-space: pre-line;">
        {{ $t('querenshanchugongshi') }}
        <br />
      </span>
      <span>
        {{ $t('yibingshanchugongshijilu') }}
      </span>

      <!-- 是否选择器 -->
      <el-radio-group v-model="deleteRelatedFlag" style="margin-right: 20px;">
        <el-radio :label="true">{{ $t('shi') }}</el-radio>
        <el-radio :label="false">{{ $t('fou') }}</el-radio>
      </el-radio-group>

      <el-table :data="relatedRecords" style="width: 100%" :header-cell-style="{ color: '#606266', 'font-weight': '700', height: '48px', padding: '0px', 'font-size': '14px' }">
        <el-table-column prop="type" :label="$t('gongshileixing')">
          <template slot-scope="scope">
            {{ $t(store.state.dictJsonAll['WORK_HOUR_TYPE'][scope.row.type]) }}
          </template>
        </el-table-column>
        <el-table-column prop="employeeNo" :label="$t('gonghao')"></el-table-column>
        <el-table-column prop="employeeName" :label="$t('xingming')"></el-table-column>
        <el-table-column prop="collectFlag" :label="$t('caijibiaoshi')">
          <template slot-scope="scope">
            {{ $t(store.state.dictJsonAll['WORK_HOUR_COLLECT_FLAG'][scope.row.collectFlag]) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('caijishijian')">
          <template slot-scope="scope">
            {{ formatDate(scope.row.collectTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="equipmentNames" :label="$t('shebeimingcheng')"></el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer">
        <el-button @click="deleteRecordDialogVisible = false">{{ $t('quxiao') }}</el-button>
        <el-button type="danger" @click="executeDelete" :loading="deleteLoading">
          {{ $t('querenshanchu') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'web_employment_management_work_hour_list',
  data() {
    return {
      isTeamLeader: false,
      teamId: null,
      orgId: null,
      workTypeOptions: [{ label: 'normalWork', value: 'Normal' }, { label: 'overtimeWork', value: 'Overtime' }],
      selectedEmployeeIds: [],
      selectedDeviceNames: [],
      selectedWorkTypes: [],
      batchForm: {
        date: null,
        shift: null,
        startTime: null,
        endTime: null
      },
      shiftOptions: [],
      shiftMap: {},
      teamWorkingEmpList: [],
      editTeamWorkingEmpList: [],//编辑弹窗的人员列表不需要校验当前用户是否班组长
      editTeamEquipmentList: [],

      teamEquipmentIds: [],
      deleteTeamEquipmentIds: [],
      // 原始完整数据
      tableDataAll: [],

      addList: [],

      // ...其他数据
      batchDialogVisible: false,
      batchLoading: false,
      selectedRows: [], // 存储选中的表格行

      columnsItem: [
        {
          label: 'shebeimingcheng',
          prop: 'equipmentName',
          type: 'slot',
          wrap: true,
          width: 120
        },
        {
          label: 'gonghao',
          prop: 'gonghao',
          type: 'slot',
          width: 80
        },
        {
          label: 'xingming',
          prop: 'name',
          type: 'slot',
          width: 200
        },
        {
          label: 'gongshileixing',
          prop: 'type',
          type: 'slot',
          width: 140
        },
        {
          label: 'shangji',
          prop: 'collectTime',
          type: 'slot',
          width: 250
        },
        {
          label: 'xiaji',
          prop: 'collectTime2',
          type: 'slot',
          width: 250
        },

        {
          label: 'caozuo',
          type: 'slot',
          wrap: true,
          fixed: 'right'
        }
      ],

      loading: false,
      currentShiftStart: null, // 当前班次开始时间
      currentShiftEnd: null, // 当前班次结束时间
      nextShiftStart: null, // 下一个班次开始时间
      nextShiftEnd: null, // 下一个班次结束时间
      editObjectCollectTime: null, // 编辑时采集时间
      editObjectCollectTime2: null, // 编辑时采集时间2
      deleteRecordDialogVisible: false, // 删除确认弹窗是否可见
      deleteRecordData: {}, // 要删除的工时记录数据
      relatedRecords: [], // 关联记录数据
      deleteRelatedFlag: false, // 是否连带删除
      deleteLoading: false, // 删除加载状态
      currentDeleteId: null,
      // 新增数据项
      workHourTypeOptions: {
        NORMAL: '0',
        OVERTIME: '1',
        EXCEPTION: '2'
      },
      collectFlagOptions: {
        CLOCK_IN: '0',
        CLOCK_OUT: '1',
        EXCEPTION_START: '2',
        EXCEPTION_END: '3'
      },
      filterTypeOptions: [],
      filteredCollectFlags: [],
      columns: [
        {
          label: 'gongshileixing',
          prop: 'type',
          type: 'dictionary',
          key: 'WORK_HOUR_TYPE'
        },
        {
          label: 'gonghao',
          prop: 'employee.jobNo'
        },
        {
          label: 'xingming',
          prop: 'employee.name'
        },
        //采集标识
        {
          label: 'caijibiaoshi',
          prop: 'collectFlag',
          type: 'dictionary',
          key: 'WORK_HOUR_COLLECT_FLAG'
        },
        //采集时间
        {
          label: 'caijishijian',
          prop: 'collectTime',
          type: 'time'
        },
        //设备
        {
          label: 'shebei',
          prop: 'equipmentNames'
        },
        //来源
        {
          label: 'laiyuanleixing',
          prop: 'sourceType',
          type: 'dictionary_tag',
          key: 'WORK_HOUR_SOURCE_TYPE'
        },

        {
          label: 'zhichenggongyi',
          prop: 'manufacturingProcess',
          type: 'dictionary_tag',
          key: 'MANUFACTURING_PROCESS'
        },

        //备注
        {
          label: 'beizhu',
          prop: 'remark'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 250,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        orderBy: 'createTime desc'
      };
      this.yt.get(1);
    }, 300);
  },
  computed: {},
  watch: {
    // 监听工时类型变化
    'yt.editObj.type': {
      handler(newVal) {
        this.$nextTick(() => this.setDefaultFlags(newVal));
      },
      immediate: true
    }
  },
  mounted() {
    this.getTeamMembers();
  },
  methods: {
    // 执行删除操作
    async executeDelete() {
      try {
        this.deleteLoading = true;
        const deleteIds = [this.currentDeleteId];
        if (this.deleteRelatedFlag) {
          // 添加所有关联记录的ID
          this.relatedRecords.forEach(record => {
            deleteIds.push(record.id);
          });
        }
        let params = {
          ids: deleteIds
        };
        await this.http.post('/web/work/hour/deleteByIds', deleteIds);

        this.$message.success(this.$t('shanchuchenggong'));
        this.yt.get(); // 刷新表格
        this.deleteRecordDialogVisible = false;
      } finally {
        this.deleteLoading = false;
      }
    },
    formatDate(timestamp) {
      return new Date(timestamp).toLocaleString();
    },
    // 显示删除确认弹窗
    async showDeleteDialog(record) {
      let res = await this.http.get('/web/work/hour/listBySameDate', {
        params: {
          id: record.id
        }
      });
      this.relatedRecords = res.data;
      this.deleteRecordData = record;
      this.currentDeleteId = record.id;

      this.deleteRecordDialogVisible = true; // 打开删除确认弹窗
      this.deleteRelatedFlag = false;
    },

    setEditData() {},
    // 保存新增之前处理参数
    beforeCreate(params, url) {
      params.sourceType = '0';
      return params;
    },
    //重置
    closeNewDialog() {
      // 重置数据(yt。editObj对象不用处理)
      this.currentShiftStart = null; // 当前班次开始时间
      this.currentShiftEnd = null; // 当前班次结束时间
      this.nextShiftStart = null; // 下一个班次开始时间
      this.nextShiftEnd = null; // 下一个班次结束时间
      this.editObjectCollectTime = null; // 编辑时采集时间
      this.editObjectCollectTime2 = null; // 编辑时采集时间2
      this.yt.isShowEditDialog = false;
    },
    // 设置默认采集标识
    setDefaultFlags(type) {
      if (type === this.workHourTypeOptions.NORMAL || type === this.workHourTypeOptions.OVERTIME) {
        this.filterTypeOptions = ['2', '3'];
        // 正常工时 & 加班工时：仅允许 上机、下机
        this.yt.editObj.collectFlag = this.collectFlagOptions.CLOCK_IN;
        this.yt.editObj.collectFlag2 = this.collectFlagOptions.CLOCK_OUT;
      } else if (type == this.workHourTypeOptions.EXCEPTION) {
        // 除外工时：仅允许 除外开始、除外结束
        this.filterTypeOptions = ['0', '1'];

        this.yt.editObj.collectFlag = this.collectFlagOptions.EXCEPTION_START;
        this.yt.editObj.collectFlag2 = this.collectFlagOptions.EXCEPTION_END;
      }
    },

    // 类型变化处理
    handleWorkTypeChange() {
      this.clearInvalidFlags();
    },

    // 清除无效的采集标识
    clearInvalidFlags() {
      const validValues = this.filteredCollectFlags.map(opt => opt.value);
      if (!validValues.includes(this.yt.editObj.collectFlag)) {
        this.yt.editObj.collectFlag = '';
      }
      if (!validValues.includes(this.yt.editObj.collectFlag2)) {
        this.yt.editObj.collectFlag2 = '';
      }
    },
    async getCurrentAndNextShift() {
      return await this.http.get('/web/setting/shift/getCurrentAndNextShift').then(response => {
        const shiftData = response.data;

        // 保存班次时间数据
        // 当前班次开始时间
        this.currentShiftStart = shiftData.currentBegin;
        // 当前班次结束时间
        this.currentShiftEnd = shiftData.currentEnd;
        // 下一个班次开始时间
        this.nextShiftStart = shiftData.nextBegin;
        // 下一个班次结束时间
        this.nextShiftEnd = shiftData.nextEnd;

        this.yt.editObj.collectTime = new Date().getTime();
      });
    },
    setShiftStartTime(index) {
      if (!this.currentShiftStart) {
        this.$message.warning(this.$t('bancishijianweihuoquqingshaohouzhongshi'));
        return;
      }
      if (index === 1) {
        this.yt.editObj.collectTime = this.currentShiftStart;
      } else if (index === 2) {
        this.yt.editObj.collectTime2 = this.currentShiftEnd;
      }
    },

    setNextShiftStartTime(index) {
      if (!this.nextShiftStart) {
        this.$message.warning(this.$t('bancishijianweihuoquqingshaohouzhongshi'));
        return;
      }
      if (index === 1) {
        this.yt.editObj.collectTime = this.nextShiftStart;
      } else if (index === 2) {
        this.yt.editObj.collectTime2 = this.nextShiftEnd;
      }
    },

    // 获取班组成员
    async getTeamMembers() {
      this.teamWorkingEmpList = [];
      this.http.get('/web/team/getTeamByUserId').then(res => {
        if (res.data == null) {
          return;
        }
        this.isTeamLeader = true;
        this.teamId = res.data.id;
        this.orgId = res.data.orgId;
        if (!this.teamId) {
          return;
        }
        this.http
          .get('/web/team/member/page', {
            params: {
              teamId: this.teamId,
              pageNum: 1,
              pageSize: 99999
            }
          })
          .then(memberRes => {
            // 将res.data.rows数组里面的empId赋给teamWorkingEmpList
            // 先提取所有emp对象，然后根据emp.id进行去重
            const empList = memberRes.data.rows.map(item => item.emp).filter(item => item.dtStatus == 1);
            // 使用Map根据emp.id进行去重，保留第一个出现的员工
            const uniqueEmpMap = new Map();
            empList.forEach(emp => {
              if (!uniqueEmpMap.has(emp.id)) {
                uniqueEmpMap.set(emp.id, emp);
              }
            });
            // 将去重后的结果转换为数组
            this.teamWorkingEmpList = Array.from(uniqueEmpMap.values());
            console.log('teamWorkingEmpList loaded:', this.teamWorkingEmpList);
          });

        this.http
          .get('/web/work/hour/getTeamEquipmentList', {
            params: {
              teamId: this.teamId
            }
          })
          .then(res => {
            if (res.data == null) {
              return;
            }
            this.teamEquipmentIds = res.data;
          });
      });
    },

    getEditTeamMembers(row) {
      this.editTeamWorkingEmpList = [];
      this.http.get('/web/employee/getTheSameTeamEmployee').then(memberRes => {
        // 根据emp.id进行去重，保留第一个出现的员工
        const uniqueEmpMap = new Map();
        memberRes.data.rows.forEach(emp => {
          if (!uniqueEmpMap.has(emp.id)) {
            uniqueEmpMap.set(emp.id, emp);
          }
        });
        // 将去重后的结果转换为数组
        this.editTeamWorkingEmpList = Array.from(uniqueEmpMap.values());
        console.log('editTeamWorkingEmpList loaded:', this.editTeamWorkingEmpList);
        this.http.get('/web/equipment/getTeamEquipmentList').then(res => {
          if (res.data == null && this.yt.editObj.action == 'xinzeng') {
            return;
          }
          this.editTeamEquipmentList = res.data;
        });
        this.yt.showEditDialog('bianji', row, 'w1');
        this.setEditData();
      }).catch(err => {
        console.log(err);
        this.$message.error(this.$t('dangqianyonghuwuquanxiancaozuo'));
      });

    },


    // 根据当前搜索条件对 allData 进行过滤
    filterData() {
      const { selectedEmployeeIds, selectedDeviceNames, selectedWorkTypes } = this;

      // 对完整数据进行过滤
      const filteredData = this.tableDataAll.filter(item => {
        const matchEmployee = selectedEmployeeIds.length === 0 || selectedEmployeeIds.includes(item.employeeId);
        const matchDevice = selectedDeviceNames.length === 0 || selectedDeviceNames.includes(item.equipmentId);
        const matchWorkType = selectedWorkTypes.length === 0 || selectedWorkTypes.includes(item.type);

        return matchEmployee && matchDevice && matchWorkType;
      });

      // 更新显示列表
      this.$refs.yt2.list = filteredData;
    },

    clearSearch() {
      this.selectedEmployeeIds = [];
      this.selectedDeviceNames = [];
      this.selectedWorkTypes = [];
      // 还原显示所有数据
      this.$refs.yt2.list = [...this.tableDataAll];
    },

    // 获取班组的所有设备，以及每台设备对应的工时历史
    async reuseRecentSchedule() {
      if (!this.isTeamLeader) {
        this.$message.error(this.$t('feibanzuzuchangwuquanxiancaozuo'));
        return;
      } else {
        this.yt.showEditDialog('fuyongzuijinpaiban', null, '1350px');
        const shiftData = await this.getCurrentAndNextShift();
        const scheduleWorhourList = await this.http.get('/web/work/hour/reuseRecentSchedule', {
          params: {
            teamId: this.teamId
          }
        });

        // 延迟处理以避免阻塞 UI
        setTimeout(() => {
          const listWithJobNo = scheduleWorhourList.data.map(item => {
            const employees = this.teamWorkingEmpList.filter(emp => item.employeeIds && item.employeeIds.includes(emp.id)) || [];
            return {
              ...item,
              gonghao: employees.map(emp => emp.jobNo).join(',') || '', // 多个工号用逗号分隔
              employeeIds: item.employeeIds || [], // 返回多个员工ID
              collectTime: item.collectTime ? item.collectTime : '',
              collectTime2: item.collectTime2 ? item.collectTime2 : ''
            };
          });

          this.tableDataAll = [...listWithJobNo];
          this.teamEquipmentIds = listWithJobNo.map(item => item.equipmentId);
          this.$refs.yt2.list = listWithJobNo;
        }, 0);
      }
    },

    handleEmployeeChange(employeeIds, row) {
      if (Array.isArray(employeeIds)) {
        // 多选时的处理
        const selectedEmployees = this.teamWorkingEmpList.filter(emp => employeeIds.includes(emp.id));
        const jobNos = selectedEmployees.map(emp => emp.jobNo).join(', ');

        this.$set(row, 'employeeIds', employeeIds); // 更新员工ID数组
        this.$set(row, 'gonghao', jobNos); // 显示工号列表或按需处理
      }
    },

    remove(index, item) {
      const list = this.$refs.yt2.list;
      const deletedItem = list.splice(index, 1)[0];

      // 合并设备ID处理
      const equipmentIdSet = new Set();
      const existingEquipmentIds = list.reduce((acc, item) => {
        if (item.equipmentId) {
          acc.add(item.equipmentId);
          equipmentIdSet.add(item.equipmentId);
        }
        return acc;
      }, new Set());

      // 使用Set优化过滤
      const targetIndex = this.tableDataAll.findIndex(item => item.id === deletedItem.id);
      if (targetIndex > -1) {
        this.tableDataAll.splice(targetIndex, 1);
      }
      this.deleteTeamEquipmentIds = this.teamEquipmentIds.filter(id => !equipmentIdSet.has(id));

      // 强制更新表格视图
      //this.$refs.yt2.list = [...this.$refs.yt2.list];
      // 提示用户删除成功
      this.$message.success(this.$t('shanchuchenggong'));
    },

    addTable(item) {
      // 检查表格中是否存在设备ID为空的行
      const hasEmptyEquipmentId = this.$refs.yt2.list.some(item => !item.equipmentId);

      if (hasEmptyEquipmentId) {
        this.$message.warning(this.$t('cunzaishebeiidweikongdehangqingxiantianxiewanzheng'));
        return;
      }
      // 获取当前表格所有行
      const list = this.$refs.yt2.list;

      // 查找是否有空的 id 行
      const emptyRows = list.filter(row => !row.id);
      if (emptyRows.length > 0) {
        // 获取当前已有设备ID列表（排除空值）
        const existingIds = list.map(row => row.id).filter(id => id); // 过滤掉 null/undefined

        // 获取当前最大ID，如果没有则从0开始
        const maxId = existingIds.length > 0 ? Math.max(...existingIds.map(Number)) : 0;

        // 给每个空行赋值唯一ID（递增）
        emptyRows.forEach((row, index) => {
          row.id = maxId + index + 1;
        });

        // 更新整个列表（如果需要响应式更新）
        this.$refs.yt2.list = [...list]; // 强制触发 Vue 响应式更新
      }

      // 获取当前表格中已存在的设备ID
      const existingEquipmentIds = this.$refs.yt2.list.map(item => item.equipmentId);

      // 计算可选的设备ID = 班组所有设备 - 已存在的设备
      this.deleteTeamEquipmentIds = this.teamEquipmentIds.filter(id => !existingEquipmentIds.includes(id));

      if (this.deleteTeamEquipmentIds.length === 0) {
        this.$message.error(this.$t('meiyoukeyongdeshebeikeyixinzeng'));
        return;
      }
      const newItem = {
        equipmentId: '',
        employeeId: '',
        gonghao: '',
        type: '0',
        collectTime: '',
        collectTime2: '',
        id: null
      };
      this.$refs.yt2.list.push(newItem);
      this.tableDataAll.push(newItem);
      // 页面滚动到最下方
      this.$nextTick(() => {
        const tableBody = document.querySelector('.currentTable .el-table__body-wrapper');
        if (tableBody) {
          tableBody.scrollTop = tableBody.scrollHeight;
        }
      });
    },

    submitFullData() {
      const fullData = this.tableDataAll;
      this.http
        .post('/web/work/hour/saveReuseRecentSchedule', this.tableDataAll)
        .then(res => {
          this.$message.success(this.$t(res.msg));
          this.clearResueDialog();
          this.yt.get();
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },

    clearResueDialog() {
      this.selectedEmployeeIds = [];
      this.selectedDeviceNames = [];
      this.selectedWorkTypes = [];
      this.yt.isShowEditDialog = false;
    },

    // 显示批量更新对话框
    async showBatchUpdateDialog() {
      this.batchDialogVisible = true;
      const shiftRes = await this.http.get('/web/setting/shift/getShiftListByOrgId', {
        params: {
          orgId: this.orgId
        }
      });
      this.shiftOptions = shiftRes.data.map(shift => ({
        label: shift.name,
        value: shift.id
      }));
      this.batchForm.startTime = shiftRes.data[0].startTime;
      this.batchForm.endTime = shiftRes.data[0].endTime;
      this.batchForm.shiftId = shiftRes.data[0].id;
      this.batchForm.date = new Date();
      // 用map，记录每个班次，在切换班次时，同步更新工时
      const shiftMap = new Map();
      shiftRes.data.forEach(shift => {
        shiftMap.set(shift.id, {
          startTime: shift.startTime,
          endTime: shift.endTime
        });
      });
      this.shiftMap = shiftMap;
    },

    // 处理班次变化
    async handleShiftChange(shiftId) {
      // 从shiftMap中获取班次信息
      const shiftInfo = this.shiftMap.get(shiftId);
      this.batchForm.startTime = shiftInfo.startTime;
      this.batchForm.endTime = shiftInfo.endTime;
    },

    // 执行批量更新
    async handleBatchUpdate() {
      try {
        // 校验batchForm里面的属性都必须有值
        const { date, shiftId, startTime, endTime } = this.batchForm;

        if (!date || !shiftId || !startTime || !endTime) {
          this.$message.error(this.$t('qingtianxie (bitian)'));
          return;
        } else {
          this.batchLoading = true;
          // 对this.tableDataAll里面每一条数据的collectTime和collectTime2进行赋值
          const date = this.batchForm.date; // 基础日期
          const startTimeStr = this.batchForm.startTime;
          const endTimeStr = this.batchForm.endTime;

          // 提取出时间部分并转换为时间戳（忽略日期）
          const [startHour, startMin, startSec] = startTimeStr.split(':').map(Number);
          const [endHour, endMin, endSec] = endTimeStr.split(':').map(Number);

          // 创建开始时间的时间戳（用于比较）
          const startTimeValue = new Date().setHours(startHour, startMin, startSec, 0);
          const endTimeValue = new Date().setHours(endHour, endMin, endSec, 0);

          // 判断是否跨天
          let finalDateForEndTime = date;
          if (startTimeValue > endTimeValue) {
            // 如果开始时间晚于结束时间，则结束时间加一天
            const nextDay = new Date(date);
            nextDay.setDate(nextDay.getDate() + 1);
            finalDateForEndTime = nextDay;
          }

          this.tableDataAll.forEach(item => {
            const collectTime = this.formatDateTime(date, startTimeStr);
            const collectTime2 = this.formatDateTime(finalDateForEndTime, endTimeStr);

            this.$set(item, 'collectTime', collectTime);
            this.$set(item, 'collectTime2', collectTime2);
          });
          this.batchDialogVisible = false;
        }
      } finally {
        this.batchLoading = false;
      }
    },

    // 重置批量表单
    resetBatchForm() {
      this.$refs.batchForm.resetFields();
      this.batchForm = {
        date: '',
        shift: '',
        startTime: '',
        endTime: ''
      };
    },

    // 格式化日期时间
    formatDateTime(dateStr, timeStr) {
      let date;

      if (typeof dateStr === 'string') {
        const [year, month, day] = dateStr.split('-').map(Number);
        date = new Date(year, month - 1, day);
      } else if (dateStr instanceof Date) {
        date = new Date(dateStr);
      } else {
        throw new Error('Invalid date format');
      }

      const [hours, minutes, seconds] = timeStr.split(':').map(Number);
      date.setHours(hours, minutes, seconds);

      // 严格检查是否为有效日期
      if (isNaN(date.getTime())) {
        console.error('Invalid date generated:', { dateStr, timeStr });
        return null;
      }

      return date.getTime();
    },

    updateCollectTime(row, time) {
      this.$set(row, 'collectTime', time);
      this.$forceUpdate();
    },
    updateCollectTime2(row, time) {
      this.$set(row, 'collectTime2', time);
      this.$forceUpdate();
    }
  }
};
</script>

<style scoped></style>
